
module.exports = function (ngModule) {

  ngModule.directive('store', [function () {
    return {
      restrict: 'E',
      replace: true,
      template: require('./store.html'),
      scope: {
        isOpen: '='
      },
      bindToController: true,
      controller: ['$scope', '$timeout', 'storeService', '$mdSidenav', '$rootScope', '$state', '$log', controller],
      controllerAs: 'vm'
    }
  }]);

  function controller($scope, $timeout, storeService, $mdSidenav, $rootScope, $state, $log) {
    var vm = this;


    $scope.$watch('vm.isOpen', function (open) {
      if (open) {
        activate();
      }
    })

    function activate() {
      storeService.getAll().then(function (songs) {
        vm.songs = songs;
      });
    }

    vm.new = function () {
      $state.go('root.new');
      //vm.close();
      /*
     if (!currentSong || !currentSong.created) {
       vm.song = storeService.new();
       // vm.tracks = songToArray(vm.song);
       vm.sequencer.load(vm.song.tracks);
     } else {
       $state.go('root.main', { key: undefined });
     }
     */
    }

    vm.load = function (song) {
      $state.go('root.main', { key: song.key });

    }
    vm.close = function () {
      $mdSidenav('store').close()
        .then(function () {
          $log.info("close RIGHT is done");
        });
    };


  }

}



// WEBPACK FOOTER //
// ./src/web/store/store.js